import * as React from "react";
import { Button, ButtonPrimaryInlineText, ButtonProps } from "~/sharedComponents/buttons";
import { icon } from "~/sharedComponents/icons";

type AddLinkProps = Omit<ButtonProps, "showLoadingOnAjaxActions">;

export const AddLink = React.forwardRef<Button, React.PropsWithChildren<AddLinkProps>>(
    ({ isLoading, action, ...props }, ref) => (
        <ButtonPrimaryInlineText
            {...props}
            isLoading={isLoading}
            ref={ref as any}
            iconName={icon.plus}
            action={action}
        />
    )
);
